export default interface DETAILVIEWS_RELATIONSHIP
{
	ID?                           : string;  // uniqueidentifier
	DETAIL_NAME?                  : string;  // nvarchar
	MODULE_NAME                   : string;  // nvarchar
	TITLE                         : string;  // nvarchar
	CONTROL_NAME                  : string;  // nvarchar
	RELATIONSHIP_ORDER?           : number;  // int
	TABLE_NAME                    : string;  // nvarchar
	PRIMARY_FIELD                 : string;  // nvarchar
	SORT_FIELD                    : string;  // nvarchar
	SORT_DIRECTION                : string;  // nvarchar
	// 03/31/2022 Paul.  Add Insight fields.
	INSIGHT_VIEW?                 : string;  // nvarchar
	INSIGHT_LABEL?                : string;  // nvarchar
	initialOpen?                  : boolean;
}

